import { createStyles } from "@mantine/core";

export const useLeftSectionStyle = createStyles({

})